<template>
  <v-list-item class="py-2"
               :style="!Address && !loading ? 'border: 1px solid red !important;' : ''">
    <v-list-item-icon class="mr-4 my-auto">
      <v-icon v-text="getAddressIcon()"
              :color="Address || loading ? '' : 'error'" />
    </v-list-item-icon>
    <v-list-item-content class="py-0"
                         v-if="Address && !loading">
      <v-container class="pa-0"
                   fluid>
        <v-row no-gutters>
          <v-col v-if="!hideName">
            <v-list-item-title v-text="Address.Name" />
          </v-col>
          <v-col v-if="!hideStreet">
            <v-list-item-title v-text="Address.Street" />
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-1">
          <v-col v-if="!hideCity || !hideZip">
            <v-list-item-subtitle v-text="Address.Zip + ' ' + Address.City" />
          </v-col>
          <v-col v-if="!hideCountry">
            <v-list-item-subtitle v-text="Address.Country" />
          </v-col>
        </v-row>
      </v-container>
    </v-list-item-content>
    <v-list-item-content class="py-0"
                         v-else-if="loading">
      {{$t('servicesystem.common_objects.fallbackterms.loading')}}
    </v-list-item-content>
    <v-list-item-content class="py-0 error--text"
                         v-else>
      {{$t('servicesystem.common_objects.fallbackterms.no_customer_address')}}
    </v-list-item-content>
    <v-list-item-action class="my-auto ml-3 d-flex flex-nowrap flex-row">
      <slot name="action-buttons" />
    </v-list-item-action>
  </v-list-item>
</template>


<script>
export default {
  name: "AddressTemplate",
  props: {
    Address: Object,

    hideName: Boolean,
    hideCountry: Boolean,
    hideCity: Boolean,
    hideZip: Boolean,
    hideStreet: Boolean,
    loading: Boolean,
  },
  components: {},

  data: () => ({}),

  mounted() {},

  methods: {
    getAddressIcon() {
      if (!this.Address) {
        return 'mdi-map-marker';
      }
      var id = this.Address.Id;
      // Default address (null/undefined ID or starts with '-')
      if (!id || (typeof id === 'string' || id instanceof String) && id.startsWith('-')) {
        return 'mdi-home-map-marker';
      }
      // External/ERP address (starts with '_')
      else if ((typeof id === 'string' || id instanceof String) && id.startsWith('_')) {
        return 'mdi-map-marker';
      }
      // Local address
      else {
        return 'mdi-map-marker-outline';
      }
    },
  },

  computed: {},

  watch: {
    Address: function () {},
  },
};
</script>